/* eslint-disable no-mixed-spaces-and-tabs,no-tabs,@typescript-eslint/no-unused-vars */

xplenty.directive('distinctEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./distinct-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.onValidityChange(true);
        },
      ],
    };
  },
]);
